'use strict';

(function () {
    'use strict';

    // Usage:
    // 
    // Creates:
    // 

    AppController.$inject = ['$rootScope', '$translate', 'authService', 'localStorageService'];
    angular.module('app').component('app', {
        template: '<div ui-view style="min-height:800px;"></div>',
        controller: AppController,
        controllerAs: '$ctrl',
        bindings: {
            lang: '<',
            uri: '@'
        }
    });

    function AppController($rootScope, $translate, authService, localStorageService) {
        'ngInject';

        var $ctrl = this;

        ////////////////

        $ctrl.$onInit = function () {

            /* Get current user (if logged in) */
            $ctrl.authUser = localStorageService.get('authUser');

            if ($ctrl.authUser) {
                authService.getRoles().then(function (r) {
                    $ctrl.roles = r;
                });
            }

            /* Events listeners */
            $rootScope.$on('user.login', onUserLogin);
            $rootScope.$on('user.logout', onUserLogout);

            // setLanguage($ctrl.lang);

            $translate(['app.Homepage', 'app.homepage-url']).then(function (r) {
                $ctrl.breadcrumbs = [{ label: r['app.Homepage'], url: r['app.homepage-url'] }];
            });

            /* NVD3-tooltips bug fix */
            angular.element(document).on('scroll', function () {
                angular.element('.nvtooltip.xy-tooltip').css('opacity', 0);
            });
        };

        function onUserLogin(e, user) {
            $ctrl.authUser = user;

            authService.getRoles().then(function (r) {
                $ctrl.roles = r;
            });
        }

        function onUserLogout() {
            $ctrl.authUser = null;
            $ctrl.roles = [];
        }

        $ctrl.$onDestroy = function () {};

        $ctrl.hasRole = function (role) {
            return _.includes($ctrl.roles, role);
        };
    }
})();